import { z } from 'zod'

export const highchartsLine = z.object({
  name: z.string().optional(),
  data: z.array(z.tuple([z.number(), z.number().nullable()])),
  show: z.boolean().optional(),
  visible: z.boolean().optional(),
  xAxis: z.number().int().optional(),
  yAxis: z.number().int().optional(),
  tooltip: z.object({ valueSuffix: z.string().optional() }).optional(),
  color: z.string().optional(),
  type: z.enum(['area', 'line', 'bar', 'column', 'scatter']).optional(),
  lineWidth: z.number().optional(),
  units: z.string().optional(),
  /** Unit of `data` for a length series that follows the viewer's length unit (radar only). */
  lengthUnit: z.enum(['mm', 'cm', 'm', 'ft', 'in']).optional(),
  dashStyle: z.string().optional(),
  /** Label editor (#4664), vendor sites: the sensor_sns this line is made of. */
  sensorSns: z.array(z.string()).optional(),
  /** sensor_measurement_kind_ of the line's sensors (the dashboard sorts channels into panels by it). */
  sensorKind: z.string().optional(),
  /** sensor_label_source_ id of the line's label, when it has one. */
  labelSource: z.string().optional(),
  /** An Orion thermistor with no stored depth: its assumed channel order (lowest = shallowest). Signed-in dashboards only; not public. */
  thermalOrder: z.number().optional(),
  /** A line calculated from another series (B units from VWP Hz): that series' name. Not a channel of its own. */
  derivedFrom: z.string().optional(),
})

export type HighchartsLine = z.infer<typeof highchartsLine>
